import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/ware",
            name: "ware",
            component: () => import('@/view/ware'),
            meta: {
                parent: true,
                parentName: "ware",
                name: "仓库",
                assess: true
            },
            children: [
                {
                    path: "warehouse",
                    name: "warehouse",
                    component: () => import("@/view/ware/warehouse"),
                    meta: {
                        parent: false,
                        parentName: "ware",
                        name: "仓库管理",
                        assess: true
                    }
                },
                {
                    path: "goods",
                    name: "goods",
                    component: () => import("@/view/ware/goods"),
                    meta: {
                        parent: false,
                        parentName: "ware",
                        name: "商品管理",
                        assess: true
                    }
                },
                {
                    path: "commodity",
                    name: "commodity",
                    component: () => import("@/view/ware/commodity"),
                    meta: {
                        parent: false,
                        parentName: "ware",
                        name: "商品库存管理",
                        assess: true
                    }
                },
                {
                    path: "returnList",
                    name: "returnList",
                    component: () => import("@/view/ware/returnList"),
                    meta: {
                        parent: false,
                        parentName: "ware",
                        name: "退货单管理",
                        assess: true
                    }
                },
                {
                    path: "changeList",
                    name: "changeList",
                    component: () => import("@/view/ware/changeList"),
                    meta: {
                        parent: false,
                        parentName: "ware",
                        name: "换货单管理",
                        assess: true
                    }
                },
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/router/modules/ware.js